var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header__toggle",
      attrs: { id: "header-mobile-toggle" },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggle()
        }
      }
    },
    [
      _c("span", { attrs: { id: "header__toggle--open-button" } }, [
        _vm._v("Menu")
      ]),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "lightbox__close__icon",
          attrs: { id: "header__toggle--close-button" }
        },
        [_c("use", { attrs: { "xlink:href": "#close" } })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }